import { Form } from 'antd';
import styles from './searchGroup.less?modules';
import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import ButtonML from '@/components/button_ml/ButtonML';
const SearchGroup = (props) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    for (let key in values) {
      if (!values[key]) {
        values[key] = undefined;
      }
    }
    props.handleSearch(values);
  };

  const onAdd = () => {
    form.resetFields();
    props.onAdd('add');
  };
  return (
    <Form
      form={form}
      name="control-hooks"
      onFinish={onFinish}
      className={styles.serarchFrom}
    >
      {/* 会员号 */}
      {/* <Col span={8}> */}
      <div className={styles.input_contain}>
        {/* 会员姓名 */}
        <SingInputML
          height="37px"
          labelwidth="130px"
          labelVal="模型名称"
          placeVal="请输入内容"
          name="modelName"
          allowClear={true}
        />
      </div>

      <div className={styles.btn_contain}>
        <ButtonML size="large" value="查询" htmlType="submit" fontsize="16px" />
        <ButtonML size="large" value="新增" fontsize="16px" onClick={onAdd} />
      </div>
    </Form>
  );
};

export default SearchGroup;
